import { createRoutine } from 'redux-saga-routines'

export const SET = 'ABOUT_LAYOUT/SET'
export const CONTENT = createRoutine('ABOUT_LAYOUT/CONTENT')
